export default class QueryBuilder {
    constructor() {
        this.source = 'http:\/\/data.seattle.gov/resource/v7k9-7dn4.json?$limit=50000';

        // == Select query for Socrata's SOQL
        this.soQLSelect = '&$select=';

        // == Where conditions for Socrata's SOQL
        this.soQLWhere = '&$where=';
    }

    /**
     * Get the URL for the json feed.
     */
    url() {
        return this.source + this.soQLSelect + this.soQLWhere;
    }

    /**
     * Select fields to add.
     */
    select(fields) {
        fields.forEach(field => {
            this.soQLSelect += field + ',';
        });

        this.soQLSelect = this.soQLSelect.slice(0, -1); // trim off trailing comma

        return this;
    }

    /**
     * Where conditions to add.
     */
    where(field, condition, value) {
        if ((field === 'year') && (condition === '=')) {
            this.scopeYear(value);
        }

        return this;
    }

    /**
     * Scope results to a given year.
     */
    scopeYear(year) {
        let nextYear = year + 1;
        this.soQLWhere += "incdate > '" + year + "-01-01T00:00:00' AND incdate < '" + nextYear + "-01-01T00:00:00'"
    }
}


// WEBPACK FOOTER //
// ./js/QueryBuilder.js